import { render, staticRenderFns } from "./DrawHistoryActivityDetail.vue?vue&type=template&id=51a494b6&scoped=true&"
import script from "./DrawHistoryActivityDetail.vue?vue&type=script&lang=js&"
export * from "./DrawHistoryActivityDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a494b6",
  null
  
)

export default component.exports